enum keyRoutesEnum {
  login = '/login',
  dashboard = '/schools',
}
export default keyRoutesEnum;
